import { Correct } from '../../components/Correct'
import { groupExclusions } from '../../lib/outreach'
import type { OutreachExclusion } from '../../types/outreach'

// "Not listed, and why." The point of showing forty excluded names is that one of them is wrong, so every
// line that can be answered carries the correction that answers it. Collapsed by default: this is the
// answer to a question, not part of the morning's work.
export function NotListed({ excluded }: { excluded: OutreachExclusion[] }) {
  if (excluded.length === 0) return null
  const groups = groupExclusions(excluded)
  return (
    <details className="card outreach-notlisted">
      <summary>
        <strong>{excluded.length}</strong> not listed, and why
        <span className="muted small"> — {groups.map((g) => `${g.people.length} ${g.label.toLowerCase()}`).join(' · ')}</span>
      </summary>
      {groups.map((g) => (
        <div key={g.kind} className="outreach-notlisted-group">
          <h3>{g.label}</h3>
          <ul className="plain">
            {g.people.map((e) => (
              <li key={e.person.personId}>
                <strong>{e.person.name}</strong>
                <span className="muted small"> · {e.company}</span>
                <span className="muted small outreach-notlisted-why">{e.why}</span>
                {e.correctionKind && (
                  <Correct
                    kind={e.correctionKind}
                    entityId={e.correctionKind === 'outreach-reason' ? `${e.person.personId}:dismissed` : e.person.personId}
                    entityLabel={e.person.name}
                    currentValue={e.correctionKind === 'contact-role' ? (e.person.role ?? null) : null}
                    compact
                  />
                )}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </details>
  )
}
